export default {"src":"/_next/static/media/mfc.183eae7c.svg","height":66,"width":88,"blurWidth":0,"blurHeight":0};